import script from "./PaymentGatewayManager.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentGatewayManager.vue?vue&type=script&setup=true&lang=js"

import "./PaymentGatewayManager.vue?vue&type=style&index=0&id=f8c65586&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8c65586"]])

export default __exports__